import {walletGet} from './walletAxios';
import {LOCAL_STORAGE_FINANCIAL_USER_ID_KEY} from './authConstants';

export const loadCurrentUser = () => {
    const financialUserId = localStorage.getItem(LOCAL_STORAGE_FINANCIAL_USER_ID_KEY);
    return walletGet(`/api/v1/financial-user/${financialUserId}`);
};